import { useSelector } from 'react-redux'

import { selectedPartnershipSelector } from '../../modules/selectors/partnerships'

const useIsAdvancedPartnership = () => {
  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const { rights_holder: rightsHolderId, partner: partnerId } = selectedPartnership

  // if rightsHolder is the same as partner, show advanced partnerships dashboard content
  return Number(rightsHolderId) === Number(partnerId)
}

export default useIsAdvancedPartnership
